import React from 'react';
import { Link } from 'react-router-dom';

// Visible breadcrumb trail that pairs with the BreadcrumbList JSON-LD emitted via SEO/schema.js.
const Breadcrumbs = ({ trail }) => (
  <nav aria-label="Breadcrumb" className="max-w-5xl mx-auto px-8 pt-28 pb-2">
    <ol className="flex flex-wrap items-center gap-2 text-[11px] uppercase tracking-widest text-white/35">
      {trail.map((crumb, i) => (
        <li key={crumb.path} className="flex items-center gap-2">
          {i > 0 && <span className="text-white/20">/</span>}
          {i === trail.length - 1 ? (
            <span className="text-white/60">{crumb.name}</span>
          ) : (
            <Link to={crumb.path} className="hover:text-cyan-400 transition-colors">{crumb.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
